export interface Product {
  id: string;
  productId: string;
  key: string;
  oldCode: string;
  description: string;
  shortDescription: string;
  productType: string;
  productTypeId: string;
  makeUp: string;
  stdPrice: number;
  standardCostValue: number;
  stdCutPrice: number;
  unitOfMeasure: string;
  customerKey: string;
  dateCreated: Date;
  createdBy: string;
  lastUpdatedDate: Date;
  lastUpdatedBy: string;
  conversionUomId: string;
  conversionQuantity: number;
  conversionUnit: string;
  makeUpId: string;
  totalAllocated: number;
  clearanceProduct: string;
  commodityCode: string;
  composition: string;
  hsCode: string;
  inlineAllocation: boolean;
  standardRollLength: number;
  holdStockAtProductLevel: boolean;
  calculatedStdCost: number;
  minimumOrderQuantity: number;
  minimumStockLevel: number;
  leadTime: number;
  supplierKey: string;
  supplierName: string;
  freightCost: number;
  importDuty: number;
  obsolete: string;
  partNumber: string;
  cutPrice: boolean;
  ignoreOnStockForecasting: string;
  availableProductId: string;
}
